import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router";
import { useAppSelector } from "@store";
import { createProjectRootUrl } from "utils";
import { maxStringBy } from "utils/arrayHelper";

const DATA_FILE_NAME = "data";
const DICTIONARY_FILE_NAME = "dictionary";
export const useEncodedVersionId = () => {
  const { availableVersions } = useAppSelector((state) => state.projectEncodingVersion);
  const { encodedVersionId: encodedVersionIdParam, projectId: projectIdParam } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (availableVersions?.length && !encodedVersionIdParam && projectIdParam) {
      const latestVersion = maxStringBy(availableVersions, (version) => version.versionId);
      navigate(createProjectRootUrl(Number(projectIdParam), latestVersion), {
        replace: true,
      });
    }
  }, [encodedVersionIdParam, availableVersions]);
  1;

  const encodedVersion = useMemo(() => {
    const targetVersion = availableVersions.find((version) => version.versionId === encodedVersionIdParam);
    if (encodedVersionIdParam && (!availableVersions?.length || !targetVersion)) {
      return undefined;
    }
    const hasDataFile = targetVersion?.availableFiles?.includes(DATA_FILE_NAME);
    const hasDictionaryFile = targetVersion?.availableFiles?.includes(DICTIONARY_FILE_NAME);
    return { ...targetVersion, hasDataFile, hasDictionaryFile };
  }, [encodedVersionIdParam, availableVersions]);
  return {
    encodedVersion,
    encodedVersionId: encodedVersion?.versionId,
  };
};
